import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { FormattedMessage } from 'react-intl';
import Page from '../../components/page';
import style from './no-permission-page.module.less';

const renderContent = () => {
  return (
    <div className={style.container}>
      <div className={style.icon}>
        <FontAwesomeIcon icon={faLock} />
      </div>
      <div className={style.message}>
        <FormattedMessage
          defaultMessage='We are sorry, but you do not have access to this section.'
          description='noPermissions.firstLine'
          id='QDQ6z2'
        />
      </div>
      <div className={style.message}>
        <FormattedMessage
          defaultMessage='Please contact your ShipStation administrator for access.'
          description='noPermissions.secondLine'
          id='JUfYMn'
        />
      </div>
    </div>
  );
};

const NoPermissionsPage = () => {
  return <Page>{renderContent()}</Page>;
};

export default NoPermissionsPage;
